module.exports = require('./poster')



/** WEBPACK FOOTER **
 ** ./src/plugins/poster/index.js
 **/